import { render, staticRenderFns } from "./Zone.vue?vue&type=template&id=5b0ce744&scoped=true&"
import script from "./Zone.vue?vue&type=script&lang=js&"
export * from "./Zone.vue?vue&type=script&lang=js&"
import style0 from "./Zone.vue?vue&type=style&index=0&id=5b0ce744&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0ce744",
  null
  
)

component.options.__file = "Zone.vue"
export default component.exports